export default __webpack_public_path__ + "static/media/the-hatchening.0a692bc9.mp4";